import { DataTable } from "./data-table";
import { useGetAllDevices } from "../../../api/routes/devices";

const DevicesRoute = () => {
    const { data: devices, isLoading } = useGetAllDevices();

    if (isLoading) {
        return <div className="mx-auto py-10 md:px-32 px-4">Loading...</div>;
    }

    return (
        <div className="mx-auto py-10 md:px-32 px-4">
            <DataTable data={devices || []} />
        </div>
    );
};

export { DevicesRoute };
